<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{ data.title }}</h4>
        <button type="button" class="close pointer" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>{{ data.description }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c(false)">{{ data.cancelBtn }}</button>
        <button type="button" *ngIf="data.showConfirmBtn" class="btn {{data.confirmButtonClass}}" (click)="c(true)">{{ data.acceptBtn }}</button>
    </div>
</ng-template>
